module.exports = __webpack_public_path__ + "static/media/HR-team.25948e98.svg";